// extracted by mini-css-extract-plugin
export default {"signInForm":"style_signInForm__q548R","p":"style_p__GjO+c","span":"style_span__404yz","alert":"style_alert__J9C76"};